import React, {Component} from "react";
import {
  Icon
} from 'antd';
import UserCardList from "./UserCardList";
import CardRegistration from "./CardRegistration";

export default class FeedWithCard extends Component {
  render() {
    return <div className={"flex justify-center flex-col"}
                style={{"padding": "1.5rem", "height": "100%"}}>
      <div style={{"maxHeight": "150px", "overflowY": "scroll"}}
           className={"mb-3"}>
        <UserCardList
          isCommunity={0}
          orderId={this.props.orderId}
          isCreditNote={this.props.creditNote}
          creditNoteId={this.props.creditNoteId}
          isRefund={this.props.refund}
          redirectionURL={this.props.redirectionURL}
          amount={this.props.amount}
        />
      </div>
      <CardRegistration
        isCommunity={0}
        orderId={this.props.orderId}
        isCreditNote={this.props.creditNote}
        creditNoteId={this.props.creditNoteId}
        isRefund={this.props.refund}
        redirectionURL={this.props.redirectionURL}
        amount={this.props.amount}
      />
      {this.props.mangoPay.showSpinner ?
        <div className="div-fetching-file flex items-center justify-center ">
          <Icon type="sync" spin style={{fontSize: "50px"}}/>
        </div> : null
      }
    </div>;
  }
}




// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/FeedWithCard.js